import { Component } from '@angular/core';
import { Inject } from '@angular/core';
import { OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/shared/components/blocks/notification/notification.service';


import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  templateUrl: './export-audit-dialog.component.html',
})
export class ExportAuditDialogComponent implements OnInit {

  public loading: boolean = false;

  public dateRangeForm: FormGroup;

  public startDate: Date;
  public endDate: Date;
  public maxDate = new Date();

  constructor
    (
      @Inject(MAT_DIALOG_DATA) public data: any,
      private formBuilder: FormBuilder,
      private apiService: ApiService,
      private notificationService: NotificationService,
      private translationService: TranslateService,
      public dialogRef: MatDialogRef<ExportAuditDialogComponent>
    ) {
  }

  public ngOnInit(): void {
    this.buildForm();
  }

  public close(): void {
    this.dialogRef.close();
  }

  public onClickExportCommand(): void {
    this.loading = true;
    this.apiService.exportAudit(this.data.deviceId, this.dateRangeForm.controls['start'].value, this.dateRangeForm.controls['end'].value).subscribe({
      next: (data) => {
        this.downloadBlob(data, 'messages.xlsx');
      },
      error: () => {
        this.loading = false;
        this.notificationService.displayError(this.translationService.instant('DEVICE_DETAIL.TAB_AUDITTRAIL.EXPORT.ERROR'));
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  private buildForm(): void {
    this.dateRangeForm = this.formBuilder.group({
      start: new FormControl({
        value: '',
        disabled: false
      }, [Validators.required]),
      end: new FormControl({
        value: this.maxDate,
        disabled: false
      }, [Validators.required])
    });

    this.dateRangeForm.get('start').valueChanges.subscribe(val => {
      if (!val || val === null) return;
      this.startDate = val;
      // Could not make it work
      // this.dateRangeForm.controls['end'].clearValidators();
      // this.dateRangeForm.controls['end'].setValidators([Validators.required, Validators.min(val)]);
      // this.dateRangeForm.controls['end'].updateValueAndValidity();
    });

    this.dateRangeForm.get('end').valueChanges.subscribe(val => {
      if (!val || val === null) return;
      this.endDate = val;
      // Could not make it work
      //this.dateRangeForm.controls['start'].setValidators([Validators.required, Validators.max(val)]);
      //this.dateRangeForm.controls['start'].updateValueAndValidity();
    });
  }

  private downloadBlob(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');

    a.href = url;
    a.download = filename || 'download';

    const clickHandler = () => {
      setTimeout(() => {
        URL.revokeObjectURL(url);
        window.removeEventListener('click', clickHandler);
      }, 150);
    };

    a.addEventListener('click', clickHandler, false);
    a.click();
  }

}
